import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as recipeReducer from "containers/Recipe/reducer";

import TraySolutionTile from "components/Tiles/TraySolutionTile";

class TraySolutionItem extends React.PureComponent {
  render() {
    const { solution, isCreating, onClick, style } = this.props;

    return (
      <div style={style}>
        <TraySolutionTile solution={solution} isCreating={isCreating} onClick={onClick} />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  handleDelete: () => dispatch(recipeReducer.deleteRecipe(ownProps.id))
});

const mapStateToProps = (state, ownProps) => {
  const solution = recipeReducer.getSolution(state, ownProps.id);

  return {
    solution: solution,
    isCreating: recipeReducer.isRecipeCreating(state, solution.id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(TraySolutionItem);
